<div class="title">
  <slot />
</div>

<style>
  .title {
    font-size: 1.5rem;
    font-weight: bold;
    padding-left: 1rem;
  }
</style>
